




























































































import Vue from "vue";
import { Component, Prop, Emit } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import FactorGroupScoringDefinition from "@/components/scoring-definition/FactorGroupScoringDefinition.vue";
import SimpleMenuTextEditor from "@/components/common/SimpleMenuTextEditor.vue";
import ConfirmationDialog from "@/components/common/ConfirmationDialog.vue";
import { Factor, FactorGroup } from "@/api/model/FactorResource";
import Modelling from "@/store/modules/Modelling";
import TableEditor from "@/views/ModelBuilder/TableEditor.vue";
import { property } from "lodash";

const modellingModule = getModule(Modelling);

@Component({
    components: {
        FactorGroupScoringDefinition,
        SimpleMenuTextEditor,
        ConfirmationDialog,
        TableEditor,
    },
})
export default class FixedTableAdditionalMenu extends Vue {
    
    private menuOpen = false;

    @Prop({ default: "", type: String })
    type: string;

    @Prop()
    factors: any;

    @Prop({ default: {} })
    element: any;

    @Prop({ default: "", type: String })
    name: any;

    @Emit("deleteAgree")
    private deleteAgree() {
        this.menuOpen = false;
    }

    private deleteDisagree() {
        this.menuOpen = false;
    }

    @Emit("keyClick")
    private keyClick() {
        this.menuOpen = false;
    }

    @Emit("submitFactorScoringSum")
    private submitFactorScoringSum($event) {
        this.menuOpen = false;
        return $event;
    }

    private cancel() {
        this.menuOpen = false;
    }

    private deleteColMsg() {
        return "Do you want to delete " + this.name + ": " + this.element.name + "?";
    }

    @Emit("colSubmit")
    private submit() {
        this.menuOpen = false;
    }

    private updateGroup() {
        this.menuOpen = false;
    }
}
